import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "step-editor" };
const _hoisted_2 = { class: "step-editor-header" };
const _hoisted_3 = { class: "locale-tabs" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "loc-short" };
const _hoisted_6 = { class: "max-messages-selector" };
const _hoisted_7 = { class: "count-btns" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "steps-list" };
const _hoisted_10 = { class: "step-number" };
const _hoisted_11 = { class: "step-content" };
const _hoisted_12 = { class: "step-timing" };
const _hoisted_13 = { class: "delay-days-options" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "field-row-2" };
const _hoisted_16 = { class: "field-group" };
const _hoisted_17 = { class: "field-label" };
const _hoisted_18 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_19 = { class: "field-group" };
const _hoisted_20 = { class: "field-label" };
const _hoisted_21 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_22 = {
    key: 0,
    class: "step-connector"
};
const _hoisted_23 = { class: "step-save-row" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = {
    key: 0,
    class: "btn-spinner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "step-title" }, "Séquence de messages", -1)),
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (loc) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: loc.code,
                        class: _normalizeClass(['locale-tab', { active: _ctx.activeLocale === loc.code }]),
                        onClick: ($event) => (_ctx.activeLocale = loc.code)
                    }, [
                        _createElementVNode("span", null, _toDisplayString(loc.flag), 1),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(loc.code.toUpperCase()), 1)
                    ], 10, _hoisted_4));
                }), 128))
            ]),
            _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "field-label" }, "Nombre de messages max", -1)),
                _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (n) => {
                        return _createElementVNode("button", {
                            key: n,
                            class: _normalizeClass(['count-btn', { active: _ctx.maxMessages === n }]),
                            onClick: ($event) => (_ctx.setMaxMessages(n))
                        }, _toDisplayString(n), 11, _hoisted_8);
                    }), 64))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps.slice(0, _ctx.maxMessages), (step, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "step-item"
                }, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(idx + 1), 1),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "field-label" }, "Délai (jours après inscription)", -1)),
                            _createElementVNode("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delayDaysOptions, (d) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        key: d.value,
                                        class: _normalizeClass(['delay-day-btn', { active: step.delayDays === d.value }]),
                                        onClick: ($event) => (step.delayDays = d.value)
                                    }, "J+" + _toDisplayString(d.label), 11, _hoisted_14));
                                }), 128))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("label", _hoisted_17, "Titre push (" + _toDisplayString(_ctx.activeLocale.toUpperCase()) + ")", 1),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event) => ((_ctx.getStepTranslation(step).pushTitle) = $event),
                                    class: "field-input",
                                    placeholder: `Titre du message ${idx + 1}`
                                }, null, 8, _hoisted_18), [
                                    [_vModelText, _ctx.getStepTranslation(step).pushTitle]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("label", _hoisted_20, "Message push (" + _toDisplayString(_ctx.activeLocale.toUpperCase()) + ")", 1),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": ($event) => ((_ctx.getStepTranslation(step).pushBody) = $event),
                                    class: "field-textarea",
                                    placeholder: `Corps du message ${idx + 1}`,
                                    rows: "2"
                                }, null, 8, _hoisted_21), [
                                    [_vModelText, _ctx.getStepTranslation(step).pushBody]
                                ])
                            ])
                        ])
                    ]),
                    (idx < _ctx.maxMessages - 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("div", { class: "connector-line" }, null, -1),
                                _createElementVNode("div", { class: "connector-icon" }, "▼", -1),
                                _createElementVNode("div", { class: "connector-line" }, null, -1)
                            ]))]))
                        : _createCommentVNode("", true)
                ]));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
                class: "btn-save-steps",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.handleSave && _ctx.handleSave(...args))),
                disabled: _ctx.isSaving
            }, [
                (_ctx.isSaving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                    : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.isSaving ? 'Enregistrement...' : '💾 Enregistrer la séquence'), 1)
            ], 8, _hoisted_24)
        ])
    ]));
}
